import {call, put} from 'redux-saga/effects';
import ClientsActions from '../redux/ClientsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getClients(api, action) {
  const response = yield call(api.getClients, {...action.props});

  if (response.ok) {
    yield put(ClientsActions.clientsSuccess({totalPages: response.data.totalPages, data: transformData(response.data.data), ...action.props}));
  } else {
    yield put(ClientsActions.clientsFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transformData = data => {
  let dt = [];
  data.map(client => {
    if (client.cars && client.cars.length > 0) {
      client.cars.map((car, index) => dt.push({
        id: `${client.id}${index > 0 ? '#' + car.id : ''}`,
        rowSpan: index === 0 ? client.cars.length : 1,
        fullName: index > 0 ? "" : client.fullName,
        phone: index > 0 ? "" : client.phone,
        car: {...car}
      }))
    } else {
      dt.push({
        ...client
      })
    }
  })
  return dt;
}